export const vibrateWaiterAlert = () => {
 if (!("vibrate" in navigator)) return;
 // Pattern: vibrate – pause – vibrate – pause – long vibrate
 navigator.vibrate([300, 150, 300, 150, 500]);
};